import React from 'react'
import styles from './Support.module.css'
import SupportSection from './SupportSection'

export default function Support() {
    const sections = [
        {
            className: styles.support1,
            title: (
                <>
                    求人リアルタイム
                    <br />
                    プレビュー
                </>
            ),
            description:
                '求人作成中に入力した内容が、求職者にどのように見えるか確認しながら進めることができます。',
        },
        {
            className: styles.support2,
            title: '店舗一括登録',
            description:
                '全国に多数店舗を保有している飲食企業様は、店舗一括登録機能により簡単に多数の店舗を登録可能。',
        },
        {
            className: styles.support3,
            title: '無料スカウト',
            description:
                '欲しい人材に直接ダイレクトメッセージ(スカウト)を送れます。',
        },
    ]

    return (
        <section className={styles.support}>
            <h2>採用サポート機能</h2>
            <ul>
                {sections.map((section, index) => (
                    <SupportSection
                        key={index}
                        className={section.className}
                        title={section.title}
                        description={section.description}
                    />
                ))}
            </ul>
        </section>
    )
}
